export enum SendType {

  EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
  EMAIL_USER_INVITE = 'EMAIL_USER_INVITE',
  EMAIL_FEATURE_EXPIRES_NOTIFICATION_ONE_WEEK = 'EMAIL_FEATURE_EXPIRES_NOTIFICATION_ONE_WEEK',
  EMAIL_FEATURE_EXPIRES_NOTIFICATION_TWO_WEEKS = 'EMAIL_FEATURE_EXPIRES_NOTIFICATION_TWO_WEEKS',
  EMAIL_ORG_INVOICE = 'EMAIL_ORG_INVOICE',
  EMAIL_ORG_COST_ESTIMATE = 'EMAIL_ORG_COST_ESTIMATE',
  EMAIL_ORG_CANCELLATION = 'EMAIL_ORG_CANCELLATION',
  EMAIL_ORG_DELIVERY_NOTE = 'EMAIL_ORG_DELIVERY_NOTE',
  EMAIL_ORG_PROFORMA_INVOICE = 'EMAIL_ORG_PROFORMA_INVOICE',
  EMAIL_ORG_CONTACT_VEHICLE_INSPECTION_NOTIFICATION = 'EMAIL_ORG_CONTACT_VEHICLE_INSPECTION_NOTIFICATION',
  EMAIL_ORG_CONTACT_VEHICLE_TIRE_CHANGE_NOTIFICATION = 'EMAIL_ORG_CONTACT_VEHICLE_TIRE_CHANGE_NOTIFICATION',
}
